<template>
  <div id="earth"></div>
</template>

<script>
import { map, throttle, isEmpty } from "lodash";
import "echarts-gl";

let echarts = require("echarts/lib/echarts");

export default {
  props: {
    firstStep: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    firstStep(val) {
      if (!val) return

      this.initEchart();
    }
  },
  data() {
    return {
      earthChart: null
    };
  },
  mounted() {
    this.initEchart();
  },
  methods: {
    initEchart() {
      if (this.earthChart) {
        this.earthChart.resize();
        this.earthChart.clear();
        this.earthChart = null;
      }

      this.earthChart = echarts.init(document.getElementById("earth"));

      const options = {
        globe: {
          show: true,
          baseTexture: require("@assets/img/menus/earth.png"),
          displacementScale: 0.2,
          shading: "color",
          viewControl: {
            autoRotateAfterStill: 1,
          }
        }
      };
      this.earthChart.setOption(options);
      window.addEventListener("resize", this.chartResize);
    },
    chartResize: throttle(
      function() {
        this.earthChart && this.earthChart.resize();
      },
      100,
      { trailing: true }
    )
  },
  destroyed() {
    window.removeEventListener("resize", this.chartResize);
  }
};
</script>

<style lang="less" scoped>
#earth {
  height: 100%;
  width: 100%;
}
</style>